const HELPER_TEXTS = {
  PAGE_DESCRIPTION_TITLE: 'Página de creación de clientes',
  PAGE_DESCRIPTION:
    'Desde aquí puedes crear un nuevo cliente solo ingresa la información que se te solicita.'
};

export default HELPER_TEXTS;
